<template>
  <v-dialog
    v-model="dialogSets"
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" v-if="!exerciseSets.set || (exerciseSets.set && exerciseSets.set.length === 0)">Configurer les sets</v-btn>
      <v-btn text v-on="on" v-else>Modifier les sets</v-btn>
    </template>

    <v-card>
      <v-app-bar color="#1B8A62">
        <v-toolbar-title style="color: white;">Sets</v-toolbar-title>

        <v-spacer />

        <v-btn icon dark @click="dialogSets = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-row class="p-5">
        <v-text-field
          label="Série(s)"
          v-model="generator.set"
          dense
          type="number"
        ></v-text-field>

        <v-row>
          <v-col
            cols=6
            v-for="(field, key) in generator.fields"
            :key="key"
          >
            <v-row>
              <v-col :cols="field.id === 1 ? 4 : 6">
                <v-select
                  dense
                  :label="field.name + ' : ' "
                  v-model="field.radio.value"
                  :items="[
                    { text: '', value: null },
                    { text: 'Fixe', value: 0 },
                    { text: 'Ascendant', value: 4 },
                    { text: 'Descandant', value: 5 },
                    { text: 'Pyramide', value: 1 },
                    { text: 'Pyramide inversée', value: 2 },
                    { text: 'Aléatoire', value: 3 },
                  ]"
                />
              </v-col>

              <v-col cols=2 v-if="field.id === 1">
                <v-select
                  dense
                  label="Unité"
                  v-model="exerciseSets.unitId"
                  :items="units"
                />
              </v-col>

              <v-col cols=6>
                <v-row v-if="field.radio.value == 0">
                  <v-text-field
                    dense
                    label="Valeur"
                    v-if="field.type !== 'time'"
                    :type="field.type"
                    v-model="field.value.value"
                    step="1"
                  />

                  <vue-timepicker
                    v-else
                    label="Valeur"
                    :type="field.type"
                    v-model="field.value.value"
                    format="HH:mm:ss"
                  />
                </v-row>

                <v-row v-else-if="field.radio.value == 3">
                  <v-col cols=6 class="py-0">
                    <v-text-field
                      v-if="field.type !== 'time'"
                      dense
                      label="Min"
                      :type="field.type"
                      v-model="field.min.value"
                      step="1"
                    />

                    <vue-timepicker
                      v-else
                      label="Min"
                      :type="field.type"
                      v-model="field.min.value"
                      format="HH:mm:ss"
                    />
                  </v-col>

                  <v-col cols=6 class="py-0">
                    <v-text-field
                      v-if="field.type !== 'time'"
                      dense
                      label="Max"
                      :type="field.type"
                      v-model="field.max.value"
                      step="1"
                    />

                    <vue-timepicker
                      v-else
                      label="Min"
                      :type="field.type"
                      v-model="field.max.value"
                      format="HH:mm:ss"
                    />
                  </v-col>
                </v-row>

                <v-row v-else-if="[1, 2, 4, 5].includes(field.radio.value)">
                  <v-col cols=6 class="py-0">
                    <v-text-field
                      v-if="field.type !== 'time'"
                      dense
                      label="Max"
                      :type="field.type"
                      v-model="field.max.value"
                      step="1"
                    />

                    <vue-timepicker
                      v-else
                      label="Min"
                      :type="field.type"
                      v-model="field.max.value"
                      format="HH:mm:ss"
                    />
                  </v-col>

                  <v-col cols=6 class="py-0">
                    <v-text-field
                      v-if="field.type !== 'time'"
                      dense
                      label="Pas"
                      :type="field.type"
                      v-model="field.step.value"
                      step="1"
                    />

                    <vue-timepicker
                      v-else
                      label="Min"
                      :type="field.type"
                      v-model="field.step.value"
                      format="HH:mm:ss"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row>

      <v-row class="p-5">
        <v-btn @click="generateSets">générer les sets</v-btn>

        <v-spacer />

        <v-btn
          @click="saveSets(exerciseSets)"
        >
          OK
        </v-btn>
      </v-row>

      <v-list class="list-set">
        <v-list-item
          v-for="(set, idx) in sets"
          :key="idx"
        >
          <v-text-field
            dense
            hide-details
            label="Répétition"
            v-model="set.rep"
          />

          <v-text-field
            dense
            hide-details
            label="Charge"
            v-model="set.fm"
            :suffix="unitValue"
          />

          <div class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted">
            <div class="v-input__control">
              <div class="v-input__slot">
                <div class="v-text-field__slot">
                  <label for="input-1601" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">
                    Temps de travail
                  </label>

                  <vue-timepicker
                    dense
                    label="Temps de travail"
                    v-model="set.tpsDeTravail"
                    type="time"
                    format="HH:mm:ss"
                  />
                </div>
              </div>
            </div>
          </div>

          <v-text-field
            dense
            hide-details
            label="Distance"
            v-model="set.distance"
          />

          <v-text-field
            dense
            hide-details
            label="Fréquence cardiaque"
            v-model="set.fcm"
          />

          <v-text-field
            dense
            hide-details
            label="Tempo"
            v-model="set.tempo"
          />

          <div class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted">
            <div class="v-input__control">
              <div class="v-input__slot">
                <div class="v-text-field__slot">
                  <label for="input-1601" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">
                    Temps de récupération
                  </label>

                  <vue-timepicker
                    dense
                    label="Temps de travail"
                    v-model="set.tpsDeRécup"
                    type="time"
                    format="HH:mm:ss"
                  />
                </div>
              </div>
            </div>
          </div>

          <v-text-field
            dense
            hide-details
            label="Autre"
            v-model="set.autre"
          />
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
  import VueTimepicker from 'vue2-timepicker';

  import {
    stringToTime,
    timeToString,
  } from '@/helpers/utils';

  export default {
    name: "sets-modal",

    props: [
      'block',
      'exerciseSets',
    ],

    components: {
      VueTimepicker,
    },

    data: function() {
      return {
        units: [
          { text: '', value: null },
          { text: 'RM', value: 1 },
          { text: '%', value: 2 },
          { text: 'KGs', value: 3 },
          { text: 'RPE', value: 4 },
          { text: 'M', value: 5 },
        ],
        dialogSets: false,
        sets: this.exerciseSets.set || this.block.nbRep,
        generator: {
          set: this.exerciseSets.nbSets || 10,
          fields: [
            {
              id: 0,
              name: "Type de répétition",
              struct: "rep",
              type: "number",
              radio: {
                value: parseInt(this.exerciseSets.repetitionType),
                field: 'repetitionType',
              },
              min: {
                value: this.exerciseSets.repMin || 1,
                field: 'repMin',
              },
              max: {
                value: this.exerciseSets.repMax || 20,
                field: 'repMax',
              },
              value: {
                value: this.exerciseSets.nbRepetition || 10,
                field: 'nbRepetition',
              },
              step: {
                value: this.exerciseSets.step || 1,
                field: 'step',
              },
            },
            {
              id: 3,
              name: "Distance",
              struct: "distance",
              type: "number",
              radio: {
                value: parseInt(this.exerciseSets.distanceType),
                field: 'distanceType',
              },
              min: {
                value: this.exerciseSets.distanceMin || 10,
                field: 'distanceMin',
              },
              max: {
                value: this.exerciseSets.distanceMax || 100,
                field: 'distanceMax',
              },
              value: {
                value: this.exerciseSets.distance || 50,
                field: 'distance',
              },
              step: {
                value: this.exerciseSets.distanceStep || 10,
                field: 'distanceStep',
              },
            },
            {
              id: 1,
              name: "Charge",
              struct: "fm",
              type: "number",
              radio: {
                value: parseInt(this.exerciseSets.forceType),
                field: 'forceType',
              },
              min: {
                value: this.exerciseSets.forceMin || 10,
                field: 'forceMin',
              },
              max: {
                value: this.exerciseSets.forceMax || 120,
                field: 'forceMax',
              },
              value: {
                value: this.exerciseSets.force || 50,
                field: 'force',
              },
              step: {
                value: this.exerciseSets.forceStep || 10,
                field: 'forceStep',
              },
            },
            {
              id: 4,
              name: "Fréquence cardiaque",
              struct: "fcm",
              type: "number",
              radio: {
                value: parseInt(this.exerciseSets.hrateType),
                field: 'hrateType',
              },
              min: {
                value: this.exerciseSets.hrateMin || 90,
                field: 'hrateMin',
              },
              max: {
                value: this.exerciseSets.hrateMax || 140,
                field: 'hrateMax',
              },
              value: {
                value: this.exerciseSets.hrate || 100,
                field: 'hrate',
              },
              step: {
                value: this.exerciseSets.hrateStep || 10,
                field: 'hrateStep',
              },
            },
            {
              id: 2,
              name: "Temps de travail",
              struct: "tpsDeTravail",
              type: "time",
              radio: {
                value: parseInt(this.exerciseSets.effortType),
                field: 'effortType',
              },
              min: {
                value: this.exerciseSets.effortTimeMin || "00:05:00",
                field: 'effortTimeMin',
              },
              max: {
                value: this.exerciseSets.effortTimeMax || "00:20:00",
                field: 'effortTimeMax',
              },
              value: {
                value: this.exerciseSets.effortTime || "00:20:00",
                field: 'effortTime',
              },
              step: {
                value: this.exerciseSets.effortTimeStep || "00:00:30",
                field: 'effortTimeStep',
              },
            },
            {
              id: 5,
              name: "Temps de récuperation",
              struct: "tpsDeRécup",
              type: "time",
              radio: {
                value: parseInt(this.exerciseSets.restType),
                field: 'restType',
              },
              min: {
                value: this.exerciseSets.restTimeMin || "00:05:00",
                field: 'restTimeMin',
              },
              max: {
                value: this.exerciseSets.restTimeMax || "00:20:00",
                field: 'restTimeMax',
              },
              value: {
                value: this.exerciseSets.restTime || "00:01:00",
                field: 'restTime',
              },
              step: {
                value: this.exerciseSets.restTimeStep || "00:00:30",
                field: 'restTimeStep',
              },
            }
          ]
        },
      }
    },

    computed: {
      unitValue: function() {
        const unit = this.units.find((unit) => unit.value === this.exerciseSets.unitId);

        return unit ? unit.text : "";
      }
    },

    methods: {
      saveSets: function() {
        const exerciseSets = this.exerciseSets;
        exerciseSets.set = this.sets;
        exerciseSets.nbSets = this.generator.set;

        this.generator.fields.forEach((field) => {
          for (const [key, value] of Object.entries(field)) {
            if (typeof(value) === 'object') {
              exerciseSets[value.field] = value.value;
            }
          }
        });

        this.dialogSets = false;
      },

      generateSets() {
        const sets = [];

        for (let i = 0; i < this.generator.set; i++) {
          sets[i] = { name: "Set " + (i + 1).toString().padStart(2, '0') };
        }

        this.generator.fields.forEach((o) => {
          switch (o.radio.value) {
            case 0:
              for (let i = 0; i < this.generator.set; i++) {
                sets[i][o.struct] = o.value.value;
              }
              break;

            case 1:
              this.processPyramide(o, false)
              .forEach(
                (value, idx) => (sets[idx][o.struct] = value)
              );
              break;

            case 2:
              this.processPyramide(o, true)
              .forEach(
                (value, idx) => (sets[idx][o.struct] = value)
              );
              break;

            case 3:
              for (let i = 0; i < this.generator.set; i++) {
                sets[i][o.struct] = this.random(o);
              }
              break;

            case 4:
              this.processSteps(o)
              .forEach(
                (value, idx) => (sets[idx][o.struct] = value)
              );
              break;

            case 5:
              this.processSteps(o, true)
              .forEach(
                (value, idx) => (sets[idx][o.struct] = value)
              );
              break;
          }
        });

        this.sets = sets;
        this.setRefresher++;
      },

      random(field) {
        let max = field.max.value;
        let min = field.min.value;

        const isTime = field.type == "time";

        if (isTime) {
          max = stringToTime(max);
          min = stringToTime(min);
        }

        const rand = Math.floor(Math.random() * (max - min + 1)) + min;

        return (isTime) ? timeToString(rand) : rand;
      },

      processSteps(field, inverted = false) {
        const list = [];
        const steps = this.generator.set;
        const isTime = field.type == "time";
        let i = 0;

        let max = field.max.value;
        let step = field.step.value;

        if (isTime) {
          max = stringToTime(max);
          step = stringToTime(step);
        }

        while(i < steps) {
          const mult = inverted ? i : steps - (i + 1);
          const value = max - (mult * step);
            
          list.push(
            (isTime) ? timeToString(value) : value
          );
          
          i++;
        }

        return list;
      },

      processPyramide(field, isInverted) {
        const list = [];
        const even = this.generator.set % 2 == 0;
        const mid = Math.floor(this.generator.set / 2);
        const isTime = field.type == "time";

        let max = field.max.value;
        let step = field.step.value;

        if (isTime) {
          max = stringToTime(max);
          step = stringToTime(step);
        }

        for (let j = 0 ; j < 2 ; j++) {
          let i = 0;
          let mult;
          let value;

          for (i ; i < mid ; i++) {
            mult = ((j && isInverted) || (!j && !isInverted )) ? (mid - (i + 1)) : i;
            mult = (!even && !isInverted) ? mult + 1 : mult;

            value = max - (mult * step);
            
            list.push(
              (isTime) ? timeToString(value) : value
            );
          }

          if (!even && j == 0) {
            mult = !isInverted ? mult - 1 : mult + 1;

            value = max - mult * step;  

            list.push(
              (field.type == "time") ? timeToString(value) : value
            );
          }
        }

        return list;
      },
    }
  }
</script>

<style>
  .v-input .display-time {
    border: none !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }

  .list-set .v-input {
    margin: 0 10px;
  }
</style>